import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Sparkles } from 'lucide-react';
import { api } from '../lib/api';
import { useAuth } from '../context/AuthContext';
import { toast } from 'sonner';

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(location.hash.replace(/^#/, '')).get('session_id');
    const target = localStorage.getItem('aurra_next') || '/chat';
    localStorage.removeItem('aurra_next');
    api.googleSession(sid)
      .then((u) => { setUser(u); window.history.replaceState(null, '', location.pathname); navigate(target, { replace: true }); })
      .catch(() => { toast.error('Connexion Google impossible'); window.history.replaceState(null, '', '/login'); navigate('/login', { replace: true }); });
    // eslint-disable-next-line
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background" data-testid="auth-callback">
      <span className="h-12 w-12 rounded-2xl bg-primary flex items-center justify-center animate-pulse"><Sparkles className="h-6 w-6 text-primary-foreground" /></span>
    </div>
  );
};

export default AuthCallback;
